module.exports = __webpack_public_path__ + "img/Slider-2.aaaf694e.jpg";